import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Skeleton from 'react-loading-skeleton';
import { Reviews as ReviewsSummary } from '@landtrustinc/design-system';
import { Reviews } from '../../components';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, customerReviews, reviewsMeta, fetchReviewsError, isFetchingReviews } = props;
  const safeReviews = Array.isArray(reviews) ? reviews : [];
  const safeCustomerReviews = Array.isArray(customerReviews) ? customerReviews : [];
  const fixedRating = reviewsMeta?.customerAverageRating || 0;
  const categoryAverages = reviewsMeta?.categoryAverages || {};

  useEffect(() => {
    if (typeof window === 'undefined' || isFetchingReviews) {
      return undefined;
    }

    const scrollToReviewAnchor = () => {
      const anchor = window.location.hash?.replace('#', '');

      if (!anchor) {
        return;
      }

      const shouldHandleAnchor = anchor === 'listingReviews' || anchor.startsWith('review-');

      if (!shouldHandleAnchor) {
        return;
      }

      const target = document.getElementById(anchor);

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    };

    scrollToReviewAnchor();
    window.addEventListener('hashchange', scrollToReviewAnchor);

    return () => {
      window.removeEventListener('hashchange', scrollToReviewAnchor);
    };
  }, [isFetchingReviews, safeReviews.length]);

  const reviewsError = (
    <h2 className={css.errorText}>
      <FormattedMessage id="ListingPage.reviewsError" />
    </h2>
  );

  if (isFetchingReviews) {
    return (
      <div className={css.sectionReviews} id="listingReviews">
        <Skeleton borderRadius={8} height={168} width="100%" />

        <div className={css.reviewsList}>
          <div className={css.reviewLoadingWrapper}>
            <div className={css.reviewLoadingHeader}>
              <Skeleton circle width={40} height={40} />
              <Skeleton borderRadius={8} height={40} width="100px" />
            </div>

            <div className={css.reviewLoadingContent}>
              <Skeleton borderRadius={8} height={192} width="100%" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Prepare items for the Reviews component from design system
  const reviewItems = [];
  if (categoryAverages.communicationRating) {
    reviewItems.push({
      label: 'Communication',
      rating: Number(categoryAverages.communicationRating),
    });
  }
  if (categoryAverages.propertyRating) {
    reviewItems.push({
      label: 'Property',
      rating: Number(categoryAverages.propertyRating),
    });
  }
  if (categoryAverages.lodgingRating) {
    reviewItems.push({
      label: 'Lodging',
      rating: Number(categoryAverages.lodgingRating),
    });
  }
  if (categoryAverages.speciesRating) {
    reviewItems.push({
      label: 'Game Abundance',
      rating: Number(categoryAverages.speciesRating),
    });
  }

  return safeReviews.length > 0 ? (
    <div className={css.sectionReviews} id="listingReviews">
      <ReviewsSummary
        averageRating={Number(fixedRating)}
        items={reviewItems}
        totalReviews={safeCustomerReviews.length}
      />
      {fetchReviewsError ? reviewsError : null}

      <div className={css.reviewsList}>
        <Reviews reviews={safeReviews} />
      </div>
    </div>
  ) : null;
};

export default SectionReviews;
